export enum AvatarResource {
  EMPLOYEE,
  RESIDENTS,
  USERS
}
